import { Server, BrainCircuit, Cloud, ShieldCheck, Database, RefreshCcw, ExternalLink } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import GlowCard from "../components/GlowCard";
import { Reveal, SectionHeading } from "../components/Reveal";

const HERO_IMG = "https://images.unsplash.com/photo-1639322537228-f710d846310a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29ya3xlbnwwfHx8fDE3OTA2MDkxNTZ8MA&ixlib=rb-4.1.0&q=85";
const icons = [Server, BrainCircuit, Cloud, ShieldCheck, Database, RefreshCcw];

export default function IbmSolutions() {
  const { t } = useLang();
  const ibm = t.ibm;

  return (
    <>
      <PageHero
        testid="ibm-hero"
        eyebrow={ibm.eyebrow}
        titleLines={ibm.title}
        paragraphs={[ibm.p1, ibm.p2]}
        image={HERO_IMG}
      />

      <section className="py-20 lg:py-28" data-testid="ibm-cards">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionHeading eyebrow="IBM" title={ibm.cardsTitle} />
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {ibm.cards.map((c, i) => {
              const Icon = icons[i];
              return (
                <Reveal key={i} delay={(i % 3) * 0.08} className="h-full">
                  <GlowCard className="h-full" testid={`ibm-card-${i}`}>
                    <div className="flex items-start justify-between">
                      <Icon className="w-7 h-7 text-cobalt" strokeWidth={1.5} aria-hidden="true" />
                      <span className="font-mono text-[10px] tracking-[0.25em] text-slate-600">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <h3 className="mt-5 font-display text-lg font-bold text-slate-100">{c.name}</h3>
                    <p className="mt-3 text-sm text-slate-400 leading-relaxed">{c.desc}</p>
                  </GlowCard>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBand title={ibm.ctaTitle} text={ibm.p1} btn={ibm.ctaBtn} />

      <section className="pb-24" data-testid="ibm-footer-meta">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <a
            href={ibm.externalUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ibm-external-link"
            className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-sovereign transition-colors duration-300"
          >
            <ExternalLink className="w-4 h-4" aria-hidden="true" />
            {ibm.external}
          </a>
          <p className="text-[11px] text-slate-600 font-mono">{ibm.trademark}</p>
        </div>
      </section>
    </>
  );
}
